import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SupportTier {
  key: string;
  name?: string;
  kind?: 'one_time' | 'recurring';
  rank?: number;
}

export interface SupportStatus {
  userId: string;
  oneTimeTotalUsd: number;
  recurringActive: boolean;
  recurringSince: string | null;
  recurringMonths: number;
  lastDonationAt: string | null;
  oneTimeTier: SupportTier | null;
  recurringTier: SupportTier | null;
  effectiveTier: SupportTier | null;
  unresolvedEventCount: number;
}

export interface SupportClaimTokenResponse {
  claimToken: string;
  expiresAt: string;
  supportUrl: string;
}

@Injectable({ providedIn: 'root' })
export class SupportService {
  constructor(private http: HttpClient) {}

  getStatus(userId: string): Observable<{ status: SupportStatus }> {
    return this.http.get<{ status: SupportStatus }>(`/api/support/status?userId=${encodeURIComponent(userId)}`);
  }

  refreshStatus(userId: string): Observable<{ status: SupportStatus }> {
    return this.http.post<{ status: SupportStatus }>('/api/support/refresh', { userId });
  }

  createClaimToken(userId: string, userName?: string, email?: string, ttlHours = 48): Observable<SupportClaimTokenResponse> {
    return this.http.post<SupportClaimTokenResponse>('/api/support/claim-token', {
      userId,
      userName,
      email,
      ttlHours,
    });
  }
}
